var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { FTLDots } from "../FTLDots";
import { typography } from "../../shared/theme";
export const FTLButton = React.forwardRef((_a, ref) => {
    var { variant = "contained", color = "primary", async, children, disabled, isSelected = false } = _a, otherProps = __rest(_a, ["variant", "color", "async", "children", "disabled", "isSelected"]);
    const classes = useStyles({ async });
    return (React.createElement(Button, Object.assign({}, otherProps, { ref: ref, variant: variant, color: color, disableRipple: true, disabled: disabled, classes: {
            root: classes.root,
            sizeLarge: classes.large,
            focusVisible: classes.focus,
            containedSecondary: `${classes.secondary} ${isSelected ? classes.selected : ""}`,
            textSecondary: classes.textSecondary,
            containedPrimary: classes.primary,
            text: classes.tertiary,
            disabled: classes.disabled,
            label: classes.label,
        } }),
        async && (React.createElement(FTLDots, { className: classes.dots, color: variant === "contained" && color === "primary"
                ? "light"
                : "tertiary" })),
        React.createElement("span", { className: classes.buttonContentWrapper, style: { color: async ? "transparent" : "inherit" } }, children)));
});
const useStyles = makeStyles((theme) => ({
    root: {
        padding: "4px 12px",
        minHeight: 32,
        minWidth: 32,
        boxShadow: "none",
        textTransform: "none",
        "&:hover, &:active": {
            boxShadow: "none !important",
        },
    },
    buttonContentWrapper: {
        width: "inherit",
        display: "inherit",
        alignItems: "inherit",
        justifyContent: "inherit",
    },
    dots: {
        position: "absolute",
        margin: "auto",
    },
    primary: {
        backgroundColor: theme.palette.button.primaryEnabled,
        "&:hover": {
            backgroundColor: theme.palette.button.primaryHover,
        },
        "&:active": {
            backgroundColor: theme.palette.button.primaryPressed,
        },
        "& $label": {
            fontWeight: 600,
        },
    },
    label: {
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "-0.09px",
        "& .MuiButton-iconSizeMedium > :first-child": {
            fontSize: 12,
        },
    },
    large: {
        minHeight: "40px",
        padding: "10px 22px",
    },
    focus: {
        boxShadow: `0 0 0 2px ${theme.palette.border.focus} !important`,
    },
    selected: {
        backgroundColor: `${theme.palette.button.secondarySelected} !important`,
        "& $label": {
            color: `${theme.palette.text.onColor} !important`,
        },
    },
    secondary: {
        backgroundColor: theme.palette.button.secondaryEnabled,
        "& $label": Object.assign(Object.assign({}, typography.unsupportedSemanticTags.buttonTextSecondary), { color: theme.palette.text.secondary }),
        "&:hover": {
            backgroundColor: theme.palette.button.secondaryHover,
        },
        "&:active": {
            backgroundColor: theme.palette.button.secondaryPressed,
            "& $label,  & $label svg": {
                color: `${theme.palette.text.onColor} !important`,
            },
        },
    },
    disabled: {
        backgroundColor: `${theme.palette.button.disabled} !important`,
        "& $label": {
            color: theme.palette.text.disabled,
        },
    },
    textPrimary: {},
    textSecondary: {
    // ...typography.unsupportedSemanticTags.buttonTextSecondary,
    },
    tertiary: {
        color: theme.palette.text.tertiary,
        "&:hover": { backgroundColor: theme.palette.button.tertiaryHover },
        "&:active": {
            backgroundColor: theme.palette.button.tertiaryPressed,
            "& $label,  & $label svg": {
                color: `${theme.palette.text.onColor} !important`,
            },
        },
    },
}));
//# sourceMappingURL=index.js.map